import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import "../../epics/index.js";
import { loadAnalysisRulesEpicReducer, deleteAnalysisRulesEpicReducer } from "./List.epics.js";
const defaultReducerState = {
  analysisRules: getDefaultAsyncWrapperObj(),
  deleteAnalysisRule: getDefaultAsyncWrapperObj()
};
const reducer = (state = defaultReducerState, action) => {
  state = loadAnalysisRulesEpicReducer.reduxChange(state, action);
  state = deleteAnalysisRulesEpicReducer.reduxChange(state, action);
  switch (action.type) {
    default:
      return state;
  }
};
export {
  reducer as default,
  defaultReducerState,
  reducer
};
//# sourceMappingURL=List.ducks.js.map
